import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Footer.css';
import {
    FaInstagram,
    FaFacebookF,
    FaTelegramPlane,
    FaWhatsapp,
    FaEnvelope
} from 'react-icons/fa';

export default function Footer() {
    const { t } = useTranslation();

    return (
        <footer className="site-footer minimal-footer">
            <div className="footer-inner">

                {/* BRAND */}
                <div className="footer-section">
                    <h4 className="footer-title">
                        Adam <span>Voyage</span>
                    </h4>

                    <p className="footer-text">
                        {t("footer.description")}
                    </p>
                </div>

                {/* QUICK LINKS */}
                <div className="footer-section">
                    <h4 className="footer-title">
                        {t("footer.quick_links")}
                    </h4>

                    <ul className="footer-links">
                        <li><Link to="/" className="footer-link">{t("nav.home")}</Link></li>
                        <li><Link to="/about" className="footer-link">{t("nav.about")}</Link></li>
                        <li><Link to="/services" className="footer-link">{t("nav.services")}</Link></li>
                        <li><Link to="/contact" className="footer-link">{t("nav.contact")}</Link></li>
                        <li><Link to="/gallery" className="footer-link">{t("nav.gallery")}</Link></li>
                        <li><Link to="/tours" className="footer-link">{t("nav.tours")}</Link></li>
                        <li><Link to="/uzbekistan" className="footer-link">{t("nav.uzbekistan")}</Link></li>
                        <li><Link to="/cuisine" className="footer-link">{t("nav.cuisine")}</Link></li>
                        <li><Link to="/experiences" className="footer-link">{t("nav.experiences")}</Link></li>
                    </ul>
                </div>

                {/* CONNECT */}
                <div className="footer-section">
                    <h4 className="footer-title">
                        {t("footer.connect")}
                    </h4>

                    <div className="footer-socials-icons-only">
                        <a href="https://instagram.com/_adamvoyage" target="_blank" rel="noopener noreferrer">
                            <FaInstagram />
                        </a>

                        <a href="https://www.facebook.com/gayrat.qilichev.9" target="_blank" rel="noopener noreferrer">
                            <FaFacebookF />
                        </a>

                        <a href="https://wa.me/998917077291" target="_blank" rel="noopener noreferrer">
                            <FaWhatsapp />
                        </a>

                        <a href="https://t.me/the_adhamjon" target="_blank" rel="noopener noreferrer">
                            <FaTelegramPlane />
                        </a>

                        <a href="mailto:sodiqovadhamjon0@gmail.com" target="_blank" rel="noopener noreferrer">
                            <FaEnvelope />
                        </a>
                    </div>
                </div>

            </div>

            <div className="footer-bottom">
                © {new Date().getFullYear()} Adam Voyage. {t("footer.rights")}
            </div>
        </footer>
    );
}